import React from 'react';
import { Footer, ImageComponent } from '../components';
import { Container, Row, Col } from 'react-bootstrap';
import { AppStoreDownloadUrl } from '../assets/urls'; 
import { 
    // TikTokIcon,
    // LinkedInIcon,
    appStoreIcon,
    newSlide1,
    newSlide2,
    newSlide3
    // DiscordCommunityUrl,
    // TikTokUrl,
    // LinkedInUrl,
    // DiscordSymbol
} from '../assets/images';

const Home = () => {
    return (
        <div id="home">
            <Container id="why" className="section">
                <div>
                    <p></p>
                    
                    <h1>
                        Memesical
                    </h1>

                    <p>
                        <a href={AppStoreDownloadUrl}>
                            <ImageComponent src={appStoreIcon} alt="app store icon"/>
                        </a>

                        {/* <a href={TikTokUrl}>
                            <img 
                                src={TikTokIcon} 
                                loading="lazy" 
                                alt="tiktok icon"
                                className="social-media-icon"
                            />
                        </a>
                        <a href={LinkedInUrl}>
                            <img 
                                src={LinkedInIcon} 
                                loading="lazy" 
                                alt="linkedin icon"
                                className="social-media-icon"
                            />
                        </a>
                         <a href={DiscordCommunityUrl}>
                            <img 
                                src={DiscordSymbol} 
                                loading="lazy" 
                                alt="discord icon"
                                className="social-media-icon"
                            />
                        </a> */}
                    </p>
                </div>
            </Container>

            <div id="our-approach" className="section">
                <Container>
                    <Row>
                        <Col>
                            <section class="sub-section">
                                <div class="sub-section-img-container">
                                    <ImageComponent src={newSlide1} alt="roommate gif"/>
                                </div>
                            </section>
                        </Col>
                        <Col>
                            <section class="sub-section">
                                <div class="sub-section-img-container">
                                    <ImageComponent src={newSlide2} alt="roommate gif"/>
                                </div>
                            </section>
                        </Col>
                        <Col>
                            <section class="sub-section">
                                <div class="sub-section-img-container">
                                    <ImageComponent src={newSlide3} alt="roommate gif"/>
                                </div>
                            </section>
                        </Col>
                    </Row>

                    <br/>
                </Container>
            </div>

            <Footer/>
        </div>

    );
};

export { Home }
